import { useRef, useState } from 'react';

const MOBILE_MAX_WIDTH = 768; // below Bootstrap's md

/**
 * Top-bar dropdowns hang off their button, which on a phone runs them off the
 * left edge of the screen. Below md this pins the menu across the screen just
 * under the button instead.
 *
 * Put `toggleRef` on the Dropdown.Toggle, call `onToggle(open)` from the
 * Dropdown's onToggle, and spread `menuStyle` last into the menu's style.
 */
const usePinnedMobileMenu = () => {
  const toggleRef = useRef(null);
  const [top, setTop] = useState(null);

  const onToggle = open => {
    if (!open) return;
    const pinned = window.innerWidth < MOBILE_MAX_WIDTH && toggleRef.current;
    setTop(
      pinned
        ? Math.round(toggleRef.current.getBoundingClientRect().bottom) + 8
        : null
    );
  };

  const menuStyle =
    top === null
      ? {}
      : {
          position: 'fixed',
          top,
          left: '0.75rem',
          right: '0.75rem',
          width: 'auto',
          minWidth: 0,
          maxHeight: `calc(100vh - ${top + 12}px)`
        };

  return { toggleRef, onToggle, menuStyle };
};

export default usePinnedMobileMenu;
